var map = {
	"./music-instructions.json": 4728,
	"./music-library-intro2024.json": 4729,
	"./music-library-launch2024.json": 4730,
	"./music-progression.json": 4731,
	"./startSourcesAdvanced.json": 4732,
	"./startSourcesSimple.json": 4733,
	"./startSourcesSimple2.json": 4734,
	"./startSourcesTracks.json": 4735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4496;